import React from 'react';

/**
 * DesignSection — titled row of artboards. No wrap; horizontal scroll if needed.
 */
const DesignSection = ({ title, subtitle, children, style }) => {
  return (
    <div style={{ marginBottom: 48, ...style }}>
      {title && (
        <div style={{ marginBottom: subtitle ? 4 : 16 }}>
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
            }}
          >
            {title}
          </div>
          {subtitle && (
            <div style={{ fontSize: 12, color: '#aaa', marginTop: 2 }}>{subtitle}</div>
          )}
        </div>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 32,
          alignItems: 'flex-start',
          overflowX: 'auto',
          paddingBottom: 8,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default DesignSection;
